<template></template>

<script>
export default {
  props: {
    title: {
      type: [String],
      default: null,
    }
  },
  computed: {
    // 新问
    newslist() {
      return this.$store.state.news.newsList;
    },
    // 热门彩种
    hotLotteryList() {
      return this.$store.state.lottery.hotLotteryList;
    },
  }
};
</script>